import { usePack } from 'lib/hooks';
import { FC } from 'react';
import { DropFileCatchAll } from './dropFileCatchAll';
import { isReadOnly } from "lib/utils";
import { usePackContext } from "domains/pack";

export const DropFileCatchAllWrapper: FC = ({ children }): JSX.Element => {
  const { packId } = usePackContext();
  const { data: pack } = usePack(packId);

  if (isReadOnly(pack)) return children as any;

  return (
    <DropFileCatchAll>
      {children}
    </DropFileCatchAll>
  );
}
